import React from "react";
import { Modal, View, Text, TouchableOpacity, StyleSheet } from "react-native";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import { DATE_FORMAT_DD_MM_HH_MM, formatDate } from "../../../helpers/util";

const OrderVehicleModal = ({ isVisible, orderVehicle, onClose }) => {
  const InfoText = ({ title, value }) => {
    return (
      <View style={styles.modalInfoView}>
        <Text style={styles.modalTitleText}>{title}</Text>
        <Text style={styles.modalText}>{value}</Text>
      </View>
    );
  };

  return (
    <Modal
      visible={isVisible}
      animationType="fade"
      transparent={true}
      statusBarTranslucent={true}
    >
      <View style={styles.modalContainer}>
        <View style={styles.modalContent}>
          <Text style={styles.modalTitle}>{"Informações do Pedido"}</Text>
          <InfoText title={"Placa:"} value={orderVehicle.plate} />
          <InfoText title={"Ticket:"} value={orderVehicle.ticket} />
          <InfoText title={"Modelo:"} value={orderVehicle.model} />
          <InfoText title={"Status:"} value={orderVehicle.nmStatus} />
          <InfoText title={"Pátio:"} value={orderVehicle.yard} />
          <InfoText
            title={"Dt. Pedido:"}
            value={formatDate(orderVehicle.dtRequest, DATE_FORMAT_DD_MM_HH_MM)}
          />
          {orderVehicle.valet ? (
            <InfoText title={"Manobrista:"} value={orderVehicle.valet} />
          ) : null}
          {orderVehicle.valet ? (
            <InfoText
              title={"Dt. em trânsito:"}
              value={formatDate(
                orderVehicle.dtHandling,
                DATE_FORMAT_DD_MM_HH_MM
              )}
            />
          ) : null}

          <TouchableOpacity style={styles.closeButton} onPress={onClose}>
            <Text style={styles.closeButtonText}>{"Fechar"}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContent: {
    backgroundColor: Colors.WHITE,
    padding: 20,
    borderRadius: 8,
    width: "80%",
    alignItems: "flex-start",
  },
  modalTitle: {
    fontSize: Fonts.FONT_SIZE_20,
    fontWeight: "bold",
    marginBottom: 10,
    alignSelf: "center",
  },
  modalText: {
    fontSize: Fonts.FONT_SIZE_18,
  },
  closeButton: {
    marginTop: 10,
    paddingVertical: 8,
    paddingHorizontal: 20,
    backgroundColor: Colors.PRIMARY,
    borderRadius: 5,
    alignSelf: "center",
  },
  closeButtonText: {
    fontSize: Fonts.FONT_SIZE_16,
    color: Colors.WHITE,
  },
  modalInfoView: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 5,
  },
  modalTitleText: {
    marginRight: 8,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "500",
    color: Colors.SECONDARY,
  },
});

export default OrderVehicleModal;
